import React, { useState, useEffect } from 'react';
import deleteIcon from '../../assets/Images/delete.png'; 
import editIcon from '../../assets/Images/edit.png';
import api from '../BaseURL/BaseURL';
import { useAuth } from '../Contexts/AuthContext';

const AddSource = () => {
  const [meals, setMeals] = useState([]);
  const [mealName, setMealName] = useState('');
  const [editingIndex, setEditingIndex] = useState(null); 
  const [editMealName, setEditMealName] = useState('');
  const [deleteIndex, setDeleteIndex] = useState(null);
  const { token } = useAuth();
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

   // Fetch meal types on component mount
    const fetchMeals = async () => {
      try {
        const response = await api.get('/institution/sources', {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`, // Authorization header
          },
        });
  
        if (response.status === 200 && response.data.status) {
          const mealTypes = response.data.data.map((meal) => ({
            id: meal.id, // Include the ID from the API response
            name: meal.name,
            show: meal.is_visible === 1, // Convert is_visible to boolean
          }));
          setMeals(mealTypes);
        }
      } catch (error) {
        console.error('Error fetching meal types:', error);
        setErrorMessage('حدث خطأ أثناء جلب قائمة الوجبات.');
      }
    };

    useEffect(() => {
    fetchMeals();
  }, [token]);
  

  const addMeal = async () => {
    if (mealName.trim() === '') {
      setErrorMessage('اسم المصدر مطلوب');
      setTimeout(() => setErrorMessage(''), 3000); 
      return;
    }
  
    try {
      setErrorMessage(''); // Clear previous errors
  
      // Clear the input field immediately
      setMealName('');
  
      // API call to create a meal
      const response = await api.post(
        '/institution/sources',
        { name: mealName, is_visible: '1' }, // Request body
        {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`, // Authorization header
          },
        }
      );
  
      if ((response.status === 200 || response.status === 201) && response.data.status) {

        // Fetch the updated list of meals
        fetchMeals();
  
        // Show success message
        setSuccessMessage('تمت إضافة المصدر بنجاح');
        setTimeout(() => setSuccessMessage(''), 3000); // Clear success message after 3 seconds
      }
    } catch (error) {
      console.error('Error adding meal:', error);
      setErrorMessage('حدث خطأ أثناء إضافة المصدر. يرجى المحاولة لاحقًا.');
    }
  };
  
  

  // const toggleShow = (index) => {
  //   const updatedMeals = meals.map((meal, i) =>
  //     i === index ? { ...meal, show: !meal.show } : meal
  //   );
  //   setMeals(updatedMeals);
  // };

  const deleteMeal = async (index) => {
    const mealToDelete = meals[index]; // Get the meal object to delete
  
  
    try {
      const response = await api.delete(`/institution/sources/${mealToDelete.id}`, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`, // Authorization header
        },
      });
  
      if (response.status === 200 && response.data.status) {
  
        // Update the meals list locally
        const updatedMeals = meals.filter((_, i) => i !== index);
        setMeals(updatedMeals);
  
        setDeleteIndex(null); // Reset delete index
        setSuccessMessage('تم حذف العنصر بنجاح');
        setTimeout(() => setSuccessMessage(''), 3000); // Clear success message after 3 seconds
      } else {
        console.error('Failed to delete meal:', response.data.message);
      }
    } catch (error) {
      console.error('Error deleting meal:', error);
      setErrorMessage('حدث خطأ أثناء حذف العنصر. يرجى المحاولة لاحقًا.');
      setTimeout(() => setErrorMessage(''), 3000); // Clear error message after 3 seconds
    }
  };
  
  
  
  const confirmDelete = (index) => {
    setDeleteIndex(index); // Open the popup and set the index of the meal to delete
  };
  
  const cancelDelete = () => {
    setDeleteIndex(null); // Close the popup without deleting
  };
  

  const startEditing = (index) => {
    setEditingIndex(index);
    setEditMealName(meals[index].name); // Set the current meal name for editing
  };
  
  const saveEdit = async (index) => {
    const mealToEdit = meals[index]; // Get the meal object to edit
  
    try {
      // API call to update the meal name
      const response = await api.put(
        `/institution/sources/${mealToEdit.id}`,
        { name: editMealName, is_visible: mealToEdit.show ? '1' : '0' }, // Request body
        {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`, // Authorization header
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      );
  
      if (response.status === 200 && response.data.status) {
  
        // Update the meals list locally
        const updatedMeals = meals.map((meal, i) =>
          i === index ? { ...meal, name: editMealName } : meal
        );
        setMeals(updatedMeals);
  
        // Exit edit mode and clear temporary values
        setEditingIndex(null);
        setEditMealName('');
        setSuccessMessage('تم تحديث اسم المصدر بنجاح');
        setTimeout(() => setSuccessMessage(''), 3000); // Clear success message after 3 seconds
      }
    } catch (error) {
      console.error('Error updating meal name:', error);
      setErrorMessage('حدث خطأ أثناء تحديث اسم المصدر. يرجى المحاولة لاحقًا.');
      setTimeout(() => setErrorMessage(''), 3000); // Clear error message after 3 seconds
    }
  };
  
  const toggleShow = async (index) => {
    const mealToToggle = meals[index]; // Get the meal object to toggle visibility
  
    try {
      // API call to update the is_visible field
      const response = await api.put(
        `/institution/meal-types/${mealToToggle.id}`,
        { name: mealToToggle.name, is_visible: mealToToggle.show ? '0' : '1' }, // Toggle visibility
        {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`, // Authorization header
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      );
  
      if (response.status === 200 && response.data.status) {
        console.log(response.data.message); // Log success message
  
        // Update the meals list locally
        const updatedMeals = meals.map((meal, i) =>
          i === index ? { ...meal, show: !meal.show } : meal
        );
        setMeals(updatedMeals);
  
        setSuccessMessage('تم تحديث حالة المصدر بنجاح');
        setTimeout(() => setSuccessMessage(''), 3000); // Clear success message after 3 seconds
      }
    } catch (error) {
      console.error('Error toggling meal visibility:', error);
      setErrorMessage('حدث خطأ أثناء تحديث حالة المصدر. يرجى المحاولة لاحقًا.');
      setTimeout(() => setErrorMessage(''), 3000); // Clear error message after 3 seconds
    }
  };
  
  
  const cancelEdit = () => {
    setEditingIndex(null); // Exit edit mode
    setEditMealName(''); // Clear temporary edit value
  };
  

  return (
    <div className="p-6" dir="rtl">
      {/* Title and Input Section */}
      <h1 className="text-2xl font-semibold text-gray-700 mb-4">اسم المصدر</h1>
      <div className="flex items-center gap-4 mb-6">
        <input
          type="text"
          value={mealName}
          onChange={(e) => setMealName(e.target.value)}
          placeholder="ادخل اسم المصدر"
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <button
          onClick={addMeal}
          className="bg-[#DD5B35] text-white py-2 px-6 rounded-lg focus:outline-none"
        >
          إضافة
        </button>
      </div>
      {successMessage && (
        <p className="text-green-500 mb-4">{successMessage}</p>
      )}
      {errorMessage && (
        <p className="text-red-500 mb-4">{errorMessage}</p>
      )}
      {/* Table Section */}
      <div className="w-full overflow-y-auto" style={{ height: '400px' }}>
  <table className="w-full border-collapse border border-gray-300 text-sm"> 
         <thead>
          <tr className="bg-gray-100">
            <th className="border border-gray-300 px-4 py-2 text-right">اسم المصدر</th>
            {/* <th className="border border-gray-300 px-4 py-2 text-right">عرض / إخفاء</th> */}
            <th className="border border-gray-300 px-4 py-2 text-right">الإجراء</th>
          </tr>
        </thead>
        <tbody>
          {meals.map((meal, index) => (
          <tr key={index} className="hover:bg-gray-100">
          <td className="border border-gray-300 px-4 py-2 text-right">
            {editingIndex === index ? (
              <input
                type="text"
                value={editMealName}
                onChange={(e) => setEditMealName(e.target.value)}
                className="w-full px-2 py-1 border border-gray-300 rounded-lg focus:outline-none"
              />
            ) : (
              meal.name
            )}
          </td>
          {/* <td className="border border-gray-300 px-4 py-2 text-center">
            <button
              onClick={() => toggleShow(index)}
              className={`py-1 px-3 rounded-lg ${
                meal.show ? 'bg-green-500 text-white' : 'bg-gray-500 text-white'
              }`}
            >
              {meal.show ? 'عرض' : 'إخفاء'}
            </button>
          </td> */}
          <td className="border border-gray-300 px-4 py-2 text-center flex items-center justify-center gap-2">
            {editingIndex === index ? (
              <>
                {/* Save Button */}
                <button
                  onClick={() => saveEdit(index)}
                  className="bg-green-500 text-white p-2 rounded-lg hover:bg-green-600"
                >
                  حفظ
                </button>
                {/* Cancel Button */}
                <button
                  onClick={cancelEdit}
                  className="bg-gray-500 text-white p-2 rounded-lg hover:bg-gray-600"
                >
                  إلغاء
                </button>
              </>
            ) : (
              <>
                {/* Edit Button */}
                <button
                  onClick={() => startEditing(index)}
                  className="p-2 rounded-lg hover:bg-blue-100"
                >
                  <img src={editIcon} alt="تعديل" className="w-5 h-5" />
                </button>
                {/* Delete Button */}
                <button
                    onClick={() => confirmDelete(index)}
                    className="p-2 rounded-lg hover:bg-red-100"
                  >
                    <img src={deleteIcon} alt="حذف" className="w-5 h-5" />
                  </button>
              </>
            )}
          </td>
        </tr>
        
          ))}
          {meals.length === 0 && (
            <tr>
              <td
                colSpan="3"
                className="border border-gray-300 px-4 py-2 text-center text-gray-500"
              >
                لا توجد بيانات.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>

       {/* Delete Confirmation Popup */}
       {deleteIndex !== null && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white p-6 rounded-lg shadow-lg w-96">
      <h2 className="text-xl font-semibold text-gray-700 text-center mb-4">
        هل أنت متأكد أنك تريد حذف هذا العنصر؟
      </h2>
      <div className="flex justify-around mt-4">
        <button
          onClick={() => deleteMeal(deleteIndex)} // Call the updated delete function
          className="bg-red-500 text-white py-2 px-6 rounded-lg hover:bg-red-600"
        >
          نعم
        </button>
        <button
          onClick={cancelDelete} // Cancel the delete operation
          className="bg-gray-500 text-white py-2 px-6 rounded-lg hover:bg-gray-600"
        >
          إلغاء
        </button>
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default AddSource;
